import { maxLength as raMaxLength, TextInput } from "react-admin";
import { useFormState } from "react-final-form";
import InputAdornment from "@material-ui/core/InputAdornment";

const SeoCharCountAdornment = ({ source, maxLength }) => {
  const { values } = useFormState({ subscription: { values: true } });
  const count = (values[source] && values[source].length) || 0;
  const style = { color: count > maxLength ? "red" : "inherit", whiteSpace: "nowrap" };
  return (
    <span style={style}>
      {count}/{maxLength}
    </span>
  );
};

export const SeoDescriptionInput = ({ label, source, maxLength, disabled = false, multiline = false }) => (
  <TextInput
    label={label}
    source={source}
    fullWidth
    defaultValue={""}
    validate={raMaxLength(maxLength)}
    disabled={disabled}
    multiline={multiline}
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <SeoCharCountAdornment source={source} maxLength={maxLength} />
        </InputAdornment>
      ),
    }}
  />
);
